/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import { Transition } from 'react-transition-group'
import Media from 'react-media'

import styled from '@emotion/styled'
import { css } from 'emotion'
import { topArrow, quint } from '@entrata/portals-common/lib/styled-utils'

const StyledDiv = styled('div')`
  height: auto;
  overflow: hidden;
  padding: 8px 0;
  position: relative;
  transition: opacity ${({ timeout }) => timeout}ms ${quint.easeOut},
    transform ${({ timeout }) => timeout}ms ${quint.easeOut};

  @media only screen and (min-width: 769px) {
    min-width: 200%;
    background: white;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
    overflow: inherit;
    padding: 8px 16px;
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 5;

    &:before {
      content: '';
      ${topArrow('white', '10px', '10px')}
      position: absolute;
      top: -10px;
      left: 20px;
    }
  }
`

const transitions = {
  entering: css`
    opacity: 0;
    transform: translateY(-10%);
  `,
  entered: css`
    opacity: 1;
    transform: translateY(0%);
  `,
  exiting: css`
    opacity: 0;
    transform: translateY(-10%);
  `,
}

const NavListFlyout = ({ children, ...props }) => (
  <Media query={`(min-width: ${769 / 16}em)`}>
    {match =>
      match && (
        <Transition mountOnEnter unmountOnExit {...props}>
          {status => (
            <StyledDiv timeout={props.timeout} className={transitions[status]}>
              {children}
            </StyledDiv>
          )}
        </Transition>
      )
    }
  </Media>
)

NavListFlyout.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element),
  in: PropTypes.bool,
  timeout: PropTypes.number,
}

NavListFlyout.defaultProps = {
  in: false,
  timeout: 300,
}

export default NavListFlyout
